export function validateDiscoveryButtons(buttons) {
  if (buttons == null) {
    return { ok: true, value: [] };
  }

  if (!Array.isArray(buttons)) {
    return { ok: false, error: 'כפתורי Discovery חייבים להיות מערך' };
  }

  for (let i = 0; i < buttons.length; i += 1) {
    const btn = buttons[i];
    const n = i + 1;

    if (!btn || typeof btn !== 'object') {
      return { ok: false, error: `כפתור ${n}: נתונים לא תקינים` };
    }
    if (!String(btn.text ?? '').trim()) {
      return { ok: false, error: `כפתור ${n}: חסר טקסט על הכפתור` };
    }
    if (!String(btn.message ?? '').trim()) {
      return { ok: false, error: `כפתור ${n}: חסרה הודעה לבוט` };
    }
    if (!String(btn.icon ?? '').trim()) {
      return { ok: false, error: `כפתור ${n}: חסר אייקון` };
    }
  }

  return { ok: true, value: buttons };
}

export function emptyDiscoveryButton(defaultIcon = '') {
  return {
    text: '',
    message: '',
    icon: defaultIcon,
  };
}
